import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=72cd10eb&scoped=true&"
import script from "./dialog.vue?vue&type=script&lang=js&"
export * from "./dialog.vue?vue&type=script&lang=js&"
import style0 from "./dialog.vue?vue&type=style&index=0&id=72cd10eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cd10eb",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/component/vue/dialog/dialog.vue
// module id = null
// module chunks = 